// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"57bdb992","672":"01c50ec4"}[chunkId] + ".chunk.js";
};